import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { images, recentBuyers } from "../data/content";
const FIRST_DELAY = 6000;
const SHOW_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let nextTimer: number;
    const showNext = () => {
      setIndex(Math.floor(Math.random() * recentBuyers.length));
      setMinutesAgo(Math.floor(Math.random() * 14) + 1);
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        nextTimer = window.setTimeout(showNext, GAP);
      }, SHOW_FOR);
    };
    nextTimer = window.setTimeout(showNext, FIRST_DELAY);
    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(nextTimer);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed left-3 right-3 bottom-[92px] z-50 sm:left-5 sm:right-auto sm:bottom-24" aria-live="polite" data-id="element-44" data-mp="114tka6wy1mb8">
      <AnimatePresence data-id="element-45" data-mp="1aw60205gwm0w">
        {visible && !dismissed && <motion.div key={`${buyer.name}-${minutesAgo}`} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full max-w-sm items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_16px_40px_-12px_rgba(11,31,63,0.45)] ring-1 ring-ink/10" data-id="element-46" data-mp="1ayshqsm2ohwu">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-cream object-contain" data-id="element-47" data-mp="28maqw4jnbm1d" />
            <div className="min-w-0" data-id="element-48" data-mp="2aol50emjke3s">
              <p className="text-sm text-ink" data-id="element-49" data-mp="2anjjthbtab8c">
                <strong className="font-bold" data-id="element-50" data-mp="2aqxkml4tucdo">{buyer.name}</strong> from {buyer.country} <span aria-hidden="true" data-id="element-51" data-mp="2fm36jjy8br1r">{buyer.flag}</span>
              </p>
              <p className="text-[13px] text-ink/70" data-id="element-52" data-mp="2knskp8gr0ku2">just purchased the Otoplasty Clinical Pathway System™</p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-cta" data-id="element-53" data-mp="2pkizztkqbcef">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-54" data-mp="1rz4vx2wsjdbr" />
                Verified purchase · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-ink/40 hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-brand" aria-label="Dismiss notification" data-id="element-55" data-mp="21wj5qjo7l3v3">
              <XIcon className="h-4 w-4" data-id="element-56" data-mp="1e5vm514xkpsp" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}